import { getStore } from 'redux/store';
import { selectClientId } from 'redux/user/user.selectors';

export const getClientId = () => selectClientId(getStore().getState());
